
import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import Card from '@/views/Project/Observation/components/card.vue'

@Component({
    components: { Card },
    mixins: [],
})
export default class GridView extends Mixins<MixinInterface>() {
    @Prop() observations!: any

    // MANAGE OBSERVATION
    async deleteObservation(data: any) {
        this.$emit('deleteObservation', data)
    }

    cardLoaded() {
        this.$emit('cardLoaded')
    }
}
